/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import Draggable from 'vuedraggable';

// Components
import MetadataFieldForm from './MetadataFieldForm.vue';

const __vue_script__ = {
    name: 'MetadataCategoryFields',

    components: {
        Draggable,
        MetadataFieldForm,
    },

    props: {
        addField: {
            type: Function,
            default: () => {},
        },

        categoryIndex: {
            type: Number,
            required: true,
        },

        fpType: {
            type: String,
            required: true
        },

        publicAccess: {
            type: Boolean,
            default: true
        },

        kindsPurpose: {
            type: String,
            default: undefined,
        },

        showHiddenFields: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            drag: false,
        };
    },

    computed: {
        category() {
            return this.$store.state.metadataEditor.categories[this.categoryIndex]?.category || '';
        },

        fields: {
            get() {
                return this.$store.state.metadataEditor.categories[this.categoryIndex]?.fields || [];
            },
            set(fields) {
                this.$store.commit(
                    'reorderMetadataFields',
                    { categoryIndex: this.categoryIndex, fields },
                );
            }
        }
    },

    methods: {
        onDragStart() {
            this.drag = true;
        },

        onDragEnd() {
            this.drag = false;
        },
    },
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metadata-category-fields"},[_c('header',[_c('div',{staticClass:"metadata-cell field-name"},[_vm._v(_vm._s(_vm.$t('metadata_editor.field_name'))),_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.$t('metadata_editor.field_name_tooltip')),expression:"$t('metadata_editor.field_name_tooltip')"}],staticClass:"ic-info-fill title"})]),_c('div',{staticClass:"metadata-cell field-kind"},[_vm._v(_vm._s(_vm.$t('metadata_editor.field_kind')))]),_c('div',{staticClass:"metadata-cell labelling"},[_vm._v(_vm._s(_vm.$t('metadata_editor.label_and_tooltip')))]),_c('div',{staticClass:"metadata-cell default-value"},[_vm._v(_vm._s(_vm.$t('metadata_editor.default_value')))])]),_c('draggable',{staticClass:"metadata-fields-list",attrs:{"handle":".drag-handle"},on:{"start":_vm.onDragStart,"end":_vm.onDragEnd},model:{value:(_vm.fields),callback:function ($$v) {_vm.fields=$$v},expression:"fields"}},_vm._l((_vm.fields),function(ref,fieldIndex){
var id = ref.id;
var definition = ref.definition;
return _c('metadata-field-form',{key:id,attrs:{"category-index":_vm.categoryIndex,"field-index":fieldIndex,"fp-type":_vm.fpType,"public-access":_vm.publicAccess,"kinds-purpose":_vm.kindsPurpose,"show-hidden-fields":_vm.showHiddenFields}})}),1),(!_vm.fields.length)?_c('div',{staticClass:"metadata-category-without-fields"},[_c('p',[_vm._v(_vm._s(_vm.$t('metadata_editor.no_fields_in_category')))]),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.addField(_vm.category)}}},[_vm._v(_vm._s(_vm.$t('metadata_editor.add_field')))])]):_vm._e()],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "MetadataCategoryFields.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__